export default {
  name: "MainFooter",
  data() {
    return {};
  },
  methods: {
    goToVitallianceSite() {
      window.open(this.$t('url-vitalliance-web-footer'), "_blank");
    },
  },
};
